module.exports = __webpack_public_path__ + "static/media/background-classique.2f2992ba.jpg";